import React from 'react';
import { useLocation } from 'react-router-dom';
import { linkTabs } from '../../tabHref';
import { OPERATIONS_TABS, resolveOperationsTabId } from './operationsTabsMeta';

/**
 * Operations shell state: which tab the URL selects, and nothing else.
 *
 * As thin as `useRegistersPage`, and thinner still in one respect — it does no
 * visibility filtering, because all three tabs are available to everyone who
 * reached this shell. See `operationsTabsMeta` for why that differs from
 * Registers.
 *
 * No date range either, for the Registers reason: a catalog of operations is a
 * list of things that exist now, and a recorded operation carries its own date.
 * A shell-level window would have nothing to scope.
 */
export const useOperationsPage = () => {
    const { pathname } = useLocation();

    const selectedTabId = React.useMemo(
        () => resolveOperationsTabId(pathname),
        [pathname],
    );

    const tabs = React.useMemo(() => linkTabs(OPERATIONS_TABS), []);

    return {
        tabs,
        selectedTabId,
    };
};
